import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

const D3PieChart = () => {
  const pieRootRef = useRef()

  const init = async () => {
    const s = d3.select('.pie-root svg')._groups[0][0];
    if(s) {
      return;
    }
    const svg = d3.select('.pie-root')
      .append('svg')
      .attr('width', '100%')
      .attr('height', '100%')
    const arcPathGenerator = d3.arc().innerRadius(0).outerRadius(200)

    const dataset = await (new Promise(resolve => {
      setTimeout(() => {
        resolve([['农业', 90], ['工业', 200], ['第三产业', 400]])
      });
    }))
    const pie = d3.pie().value(d => d[1]);
    const pieData = pie(dataset);

    svg.selectAll('path')
      .data(pieData)
      .enter()
      .append('path')
      .attr('d', d => {
        return arcPathGenerator(d)
      })
      .attr('fill', () => `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.8)`)
      .attr('stroke', 'black')
      .attr('transform', `translate(${pieRootRef.current.offsetWidth / 2}, ${pieRootRef.current.offsetHeight / 2})`)
      .attr('style', 'cursor: pointer;')
      .on('click', e => {
        svg.selectAll('path').attr('fill', () => `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.8)`)
        d3.select(e.currentTarget).attr('fill', `${d3.select(e.currentTarget).attr('fill').slice(0, -4)}1.0)`)
      })
      .on('mouseover', e => {
        d3.select(e.currentTarget).attr('fill', `${d3.select(e.currentTarget).attr('fill').slice(0, -4)}1.0)`)
      })
      .on('mouseout', e => {
        d3.select(e.currentTarget).attr('fill', `${d3.select(e.currentTarget).attr('fill').slice(0, -4)}0.8)`)
      })

    svg.selectAll('text')
      .data(pieData)
      .enter()
      .append('text')
      .attr('fill', '#fff')
      .attr('text-anchor', 'middle')
      .attr('transform', d => {
        const [centerX, centerY] = arcPathGenerator.centroid(d);
        const dx = pieRootRef.current.offsetWidth / 2 + centerX; 
        const dy = pieRootRef.current.offsetHeight / 2 + centerY;
        return `translate(${dx - `${d.value}`.length * 16}, ${dy})`;
      })
      .attr('style', 'cursor: pointer;')
      .text(d => `${dataset.find(item => item[1] === d.value)[0]} ${d.value}`)
      .on('mouseover', (e, d) => {
        const path = d3.select(`.pie-root path:nth-child(${dataset.length - d.index})`);
        path.attr('fill', `${path.attr('fill').slice(0, -4)}1.0)`)
      })
      .on('mouseout', (e, d) => {
        const path = d3.select(`.pie-root path:nth-child(${dataset.length - d.index})`);
        path.attr('fill', `${path.attr('fill').slice(0, -4)}0.8)`)
      })
  }

  useEffect(() => {
    init();
    window.onload = () => {
      d3.selectAll('.pie-root path')
        .attr('transform', `translate(${pieRootRef.current.offsetWidth / 2}, ${pieRootRef.current.offsetHeight / 2})`)
    }
  }, []);

  return (
    <>
      <h1 className="text-center py-3">d3 绘制饼图</h1>
      <div className="pie-root" ref={pieRootRef} style={{height: 400}}></div>
    </>
  )
}

export default D3PieChart;
